module.exports = __webpack_public_path__ + "static/img/IMG_20151224_185553.1396470b.jpg";